import { NgModule } from '@angular/core';
/**
 * Bootstrap Modules - Start
 */
import { AlertModule } from 'ngx-bootstrap/alert';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TreeviewModule } from 'ngx-treeview';
import { PopoverModule } from "ng2-popover";
import { SelectModule } from 'ng2-select';

@NgModule({
    imports: [
        AlertModule.forRoot(),
        AccordionModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        ModalModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        CollapseModule.forRoot(),
        PaginationModule.forRoot(),
        DatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        TreeviewModule.forRoot(),
        SelectModule
    ],
    exports: [
        AlertModule,
        AccordionModule,
        ButtonsModule,
        CarouselModule,
        ModalModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TooltipModule,
        TypeaheadModule,
        CollapseModule,
        PaginationModule,
        DatepickerModule,
        TimepickerModule,
        TreeviewModule,
        PopoverModule,
        SelectModule
    ]
})
export class AngularLibraryBootstrapModule {
}


// WEBPACK FOOTER //
// ./src/angular_library/angular-library-bootstrap.module.ts